/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetUniverseSystemsSystemIdNotFound
 */
export interface GetUniverseSystemsSystemIdNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetUniverseSystemsSystemIdNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetUniverseSystemsSystemIdNotFound interface.
 */
export function instanceOfGetUniverseSystemsSystemIdNotFound(value: object): value is GetUniverseSystemsSystemIdNotFound {
    return true;
}

export function GetUniverseSystemsSystemIdNotFoundFromJSON(json: any): GetUniverseSystemsSystemIdNotFound {
    return GetUniverseSystemsSystemIdNotFoundFromJSONTyped(json, false);
}

export function GetUniverseSystemsSystemIdNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseSystemsSystemIdNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetUniverseSystemsSystemIdNotFoundToJSON(json: any): GetUniverseSystemsSystemIdNotFound {
    return GetUniverseSystemsSystemIdNotFoundToJSONTyped(json, false);
}

export function GetUniverseSystemsSystemIdNotFoundToJSONTyped(value?: GetUniverseSystemsSystemIdNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

